/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit Failure.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import * as fromFlow from 'Logic/ViewsFlow.js'
import LabelButton from 'DesignSystem/LabelButton/view.js'
import React from 'react'
import Reset from 'DesignSystem/Svgs/Reset/view.js'
import useIsHovered from 'Logic/useIsHovered.js'
import { css } from "emotion"

let styles = {}
styles.Horizontal = css({label: 'Horizontal',
  flexDirection: "row",
alignItems: "center",
marginTop: 8,
marginBottom: 8,
marginLeft: 8,
userSelect: "none"})

export default function Failure({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  viewPath= "/App/MyAccount/Content/Profile/Content/MyProfessionals/MoreActions/Content/DownloadCSV/Failure"
}) {
    
    let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
    
    let setFlowTo = fromFlow.useSetFlowTo(viewPath)
    
    

  return (<React.Fragment
>
<button
 data-testid="Failure.Horizontal"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyProfessionals/MoreActions/Content/DownloadCSV/Failure"
 onClick={() => setFlowTo("/App/MyAccount/Content/Profile/Content/MyProfessionals/MoreActions/Content/DownloadCSV/DownloadAction")}
 {...isHoveredBind}
 className={`views-block ${styles.Horizontal}`}
>
<Reset
 data-testid="Failure.Reset"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyProfessionals/MoreActions/Content/DownloadCSV/Failure"
viewPath={`${viewPath}/Reset`}
 width={16}
 height={16}
 stroke="#FA4A2D"
/>
<LabelButton
 data-testid="Failure.LabelButton"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyProfessionals/MoreActions/Content/DownloadCSV/Failure"
viewPath={`${viewPath}/LabelButton`}
 text="Oops. Please, try again."
 color="#FA4A2D"
 marginLeft={6}
 marginTop={2}
/>
</button>
{children}
</React.Fragment>)
}